import jsrsasign from "jsrsasign";
import Base64 from "@/utils/base64";
const env = require("../../env/index.js");
import { getAuthorization } from '@/api/ai.js'

export function removeEmojis(str) {
  // 匹配各种表情符号的正则表达式
  // const emojiRegex = /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA70}-\u{1FAFF}]|[\u{1F680}-\u{1F6FF}]/gu;

  const emojiRegex = /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26D3\uFE0F?(?:\u200D\uD83D\uDCA5)?|\u26F9(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF43\uDF45-\uDF4A\uDF4C-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDF44(?:\u200D\uD83D\uDFEB)?|\uDF4B(?:\u200D\uD83D\uDFE9)?|\uDFC3(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4\uDEB5](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE41\uDE43\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC26(?:\u200D(?:\u2B1B|\uD83D\uDD25))?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?|\uDE42(?:\u200D[\u2194\u2195]\uFE0F?)?|\uDEB6(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE89\uDE8F-\uDEC2\uDEC6\uDECE-\uDEDC\uDEDF-\uDEE9]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDCE(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1|\uDDD1\u200D\uD83E\uDDD2(?:\u200D\uD83E\uDDD2)?|\uDDD2(?:\u200D\uD83E\uDDD2)?))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
  // 使用空字符串替换所有匹配到的表情符号
  return str.replace(emojiRegex, '')
}

/**
 * 判断图片是否能加载
 * @param {File} url - 图片在线地址
 * @returns {boolean} - 
 */
export async function canPreviewImage(url) {
    try {
        // 发起 HEAD 请求获取响应头（避免下载完整内容）
        const response = await fetch(url, { method: 'HEAD' })

        // 检查状态码是否为 200
        if (!response.ok) {
            return false
        }

        // 获取 Content-Type 头
        const contentType = response.headers.get('Content-Type')

        // 验证是否为图片类型
        return contentType && contentType.startsWith('image/')
    } catch (error) {
        // 处理网络错误或其他异常
        return false
    }
}

/**
 * 将 File 转换为 base64 对象
 * @param {File} dataURL - File 对象
 * @returns {string} - base64
 */
export function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = () => {
            // 获取 base64 格式的结果
            const base64String = reader.result
            resolve(base64String)
        }

        reader.onerror = error => {
            reject(error)
        }

        // 开始读取文件内容，结果会以 data URL（base64 格式）的形式返回
        reader.readAsDataURL(file)
    })
}

/**
 * 将 DataURL 转换为 Blob 对象
 * @param {string} dataURL - 图片的 DataURL
 * @returns {Blob} - 转换后的 Blob 对象
 */
export function dataURLToBlob(dataURL) {
    const arr = dataURL.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], { type: mime })
}

/**
 * 检测图片比例
 * @param {File} file - 原始图片文件
 */
export function detectPictureRatio(file) {
    // 检查是否为图片文件
    if (!file?.type?.startsWith('image/')) {
        console.log('上传的文件不是图片')
        return false
    }
    return new Promise((resolve, reject) => {
        const img = new Image()
        img.src = URL.createObjectURL(file)
        img.onload = () => {
            const widthToHeight = img.width / img.height
            const heightToWidth = img.height / img.width

            // 检查宽高比是否符合要求（≤1:100）或高宽比是否符合要求（≤1:100）
            const isValid = widthToHeight >= 1 / 100 && heightToWidth >= 1 / 100
            resolve({
                widthToHeight,
                heightToWidth,
                isValid,
                fileReason: isValid ? 'success' : 'ratio'
            })
        }
        img.onerror = () => {
            console.log('图片加载失败')
            resolve({
                isValid: false,
                fileReason: 'fileType' // 文件类型错误，可能修改过后缀
            })
            // reject(new Error('图片加载失败'))
        }
    })
}


/**
 * 压缩图片文件
 * @param {File} file - 原始图片文件
 * @returns {Promise<File>} - 压缩后的图片文件
 */
export function compressImage(file, targetSize) {
    // 检查是否为图片文件
    if (!file.type.startsWith('image/')) {
        console.log('上传的文件不是图片')
        return false
        // return Promise.reject(new Error('上传的文件不是图片'))
    }

    // 如果文件大小已经小于目标大小，直接返回
    if (file.size <= targetSize) {
        return Promise.resolve(file)
    }

    // eslint-disable-next-line no-unused-vars
    return new Promise((resolve, reject) => {
        const img = new Image()
        img.src = URL.createObjectURL(file)

        img.onload = () => {
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')

            // 更合理的最大尺寸限制
            const maxWidth = 1024
            const maxHeight = 1024
            let width = img.width
            let height = img.height

            // 计算压缩后的尺寸，保持宽高比
            if (width > maxWidth) {
                height *= maxWidth / width
                width = maxWidth
            }

            if (height > maxHeight) {
                width *= maxHeight / height
                height = maxHeight
            }

            canvas.width = width
            canvas.height = height

            // 绘制图片到 Canvas
            ctx.drawImage(img, 0, 0, width, height)

            // 调整质量并转换为 Blob
            let quality = 0.8 // 起始质量设为0.8

            // 使用递归替代 while 循环，避免阻塞 UI
            const tryCompress = () => {
                // 对于 PNG 图片，使用 PNG 格式，否则使用 JPEG
                const outputType =
                    file.type === 'image/png' ? 'image/png' : 'image/jpeg'

                canvas.toBlob(
                    blob => {
                        if (!blob) {
                            if (quality > 0.1) {
                                quality -= 0.1
                                tryCompress()
                            } else {
                                console.error('压缩失败')
                                // reject(
                                //     new Error('无法生成压缩后的图片')
                                // )
                            }
                            return
                        }

                        // 检查是否达到目标大小或最小质量
                        if (blob.size <= targetSize || quality <= 0.1) {
                            // 创建与原始文件相同名称和类型的 File 对象
                            const compressedFile = new File([blob], file.name, {
                                type: outputType,
                                lastModified: Date.now()
                            })

                            console.log(
                                `图片压缩成功: ${file.size / 1024 / 1024} -> ${
                                    compressedFile.size / 1024 / 1024
                                }`
                            )
                            resolve(compressedFile)
                        } else {
                            // 每次降低质量步长
                            quality = Math.max(0.1, quality - 0.15)
                            tryCompress()
                        }
                    },
                    outputType,
                    quality
                )
            }

            tryCompress()
        }

        img.onerror = () => {
            console.log('图片加载失败')
            // reject(new Error('图片加载失败'))
        }
    })
}

/**
 * 获取文件名与后缀名
 * @param {string} str
 * @returns {string} type - url/文件名
 */
export function extractFileInfo(str, type) {
    // 辅助函数：分离文件名和后缀
    function splitFileName(fullName) {
        if (!fullName) return { name: '', extension: '' }

        const lastDotIndex = fullName.lastIndexOf('.')
        if (lastDotIndex === -1 || lastDotIndex === 0) {
            // 没有点号或点号在开头（隐藏文件）
            return { name: fullName, extension: '' }
        }
        return {
            name: fullName.substring(0, lastDotIndex),
            extension: fullName.substring(lastDotIndex + 1)
        }
    }
    if (type === 'url') {
        // 从URL中提取文件名（处理查询参数和编码）
        const urlFileName = (() => {
            const match = str.match(/\/([^/?#]+)(\?|$)/)
            return match ? decodeURIComponent(match[1]) : ''
        })()

        // 解析URL文件名的名称和后缀
        const urlParts = splitFileName(urlFileName)
        return {
            fullName: urlFileName,
            name: urlParts.name,
            extension: urlParts.extension
        }
    }

    // 从备用名中提取文件名（处理特殊情况）
    const fallbackFileName = str || ''
    // 解析备用文件名的名称和后缀
    const fallbackParts = splitFileName(fallbackFileName)
    return {
        fullName: fallbackFileName,
        name: fallbackParts.name,
        extension: fallbackParts.extension
    }
}

// 获取 token
export async function getAuthorizationUtil() {
  let authorization = document.cookie.replace(/(?:(?:^|.*;\s*)slbrowser_pc_ai_assist_authorization\s*=\s*([^;]*).*$)|^.*$/, '$1')
  if (!authorization) {
    authorization = await getAuthorization()
  }
  return authorization
}

// 生成自定义提示 tip
export function generateAnswerResultTip(element, text, cb) {
  let tip = null
  let hideTimer = null
  let isInsideElement = false
  let isInsideTip = false

  // 创建并显示提示框
  const createTip = () => {
    clearTimeout(hideTimer)

    // 避免重复创建
    if (tip) return

    // 创建提示框元素
    tip = document.createElement('div')
    tip.className = 'answer-result-tip'

    // 设置提示框内容
    tip.textContent = text
    document.body.appendChild(tip)

    // 计算提示框位置（固定在元素正下方）
    const rect = element.getBoundingClientRect()
    const tipRect = tip.getBoundingClientRect()
    const viewportWidth = window.innerWidth

    // 水平居中对齐
    let left = rect.left + (rect.width - tipRect.width) / 2
    // 垂直位置：元素底部下方10px
    const top = rect.bottom + 10

    // 边界检测和调整
    if (left < 10) left = 10
    if (left + tipRect.width > viewportWidth - 10) {
      left = viewportWidth - tipRect.width - 10
    }

    tip.style.left = `${left}px`
    tip.style.top = `${top}px`
    tip.style.opacity = '1'
    tip.style.pointerEvents = 'auto'

    // 存储提示框位置信息
    tip.position = { left, top, width: tipRect.width, height: tipRect.height }

    // 绑定提示框事件
    tip.addEventListener('mouseenter', () => {
      isInsideTip = true
      clearTimeout(hideTimer)
    })

    tip.addEventListener('mouseleave', e => {
      isInsideTip = false

      // 检查是否移动到元素
      if (e.relatedTarget !== element) {
        hideTip()
      }
    })

    tip.addEventListener('click', e => {
      if (cb && typeof cb === 'function') {
        hideTip()
        cb(e)
      }
    })
  }

  // 延迟隐藏提示框
  const hideTip = () => {
    clearTimeout(hideTimer)
    hideTimer = setTimeout(() => {
      if (!isInsideElement && !isInsideTip) {
        if (tip) {
          tip.style.opacity = '0'

          setTimeout(() => {
            if (tip && tip.parentNode) {
              tip.remove()
            }
            tip = null
          }, 200)
        }
      }
    }, 250)
  }

  // 元素事件监听
  element.addEventListener('mouseenter', e => {
    isInsideElement = true
    createTip(e)
  })

  element.addEventListener('mouseleave', e => {
    isInsideElement = false

    // 检查鼠标是否移动到提示框
    if (tip && isMouseMovingToTip(e, tip.position)) {
      isInsideTip = true
      clearTimeout(hideTimer)
    } else {
      hideTip()
    }
  })

  element.addEventListener('click', e => {
    if (cb && typeof cb === 'function') {
      hideTip()
      cb(e)
    }
  })

  // 检查鼠标是否正移动到提示框（优化为仅处理下方定位）
  const isMouseMovingToTip = (event, tipPos) => {
    const { clientX, clientY } = event
    const elementRect = element.getBoundingClientRect()

    // 安全区域：元素底部和提示框顶部之间，水平方向适当扩展
    const safeZone = {
      top: elementRect.bottom,
      bottom: tipPos.top + tipPos.height + 15,
      left: Math.min(tipPos.left, elementRect.left) - 15,
      right: Math.max(tipPos.left + tipPos.width, elementRect.right) + 15
    }

    // 检查鼠标是否在安全区域内
    return (
      clientY >= safeZone.top &&
      clientY <= safeZone.bottom &&
      clientX >= safeZone.left &&
      clientX <= safeZone.right
    )
  }
}

// 生成10个随机字符串
function randomString(e) {
  e = e || 32;
  const t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  const a = t.length;
  let n = "";
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
  return n;
}

function getsignpart() {
  return {
    appId: env.appId,
    nonce: randomString(10),
    sign_type: "RSA2",
    timestamp: Date.now(),
  };
}

/**
 * @description: 所有post请求必须进行参数加密处理增加安全性
 * @param:
 * 请求接口中的所有参数
 */
function signature(signParams) {
  const data = env.publicKey;
  const signPrivateKey = Base64.decode(data);
  const rsa = jsrsasign.KEYUTIL.getKey(signPrivateKey);
  const sig = new jsrsasign.KJUR.crypto.Signature({ alg: "SHA256withRSA" });
  sig.init(rsa);
  sig.updateString(signParams);
  const sign = jsrsasign.hextob64(sig.sign());
  return sign;
}

/**
 * @description 生成基本入参
 * @returns {Object}
 */
function generateBaseParams() {
  const baseParms = {
    appId: env.appId,
    merchantId: env.merchantId,
    nonce: getsignpart().nonce,
    sign_type: getsignpart().sign_type,
    timestamp: getsignpart().timestamp,
  };
  return baseParms;
}

/**
 * @description 生成签名串
 * @returns {Object}
 */
function generateSignStr(data) {
  return Object.keys(data)
    .sort()
    .filter((k) => {
      if (
        data[k] === undefined ||
        data[k] === null ||
        data[k] === "" ||
        Number.isNaN(data[k]) ||
        Object.prototype.toString.call(data[k]) === "[object Object]" ||
        Object.prototype.toString.call(data[k]) === "[object Array]"
      ) {
        return false;
      }

      return true;
    })
    .map((k) => `${k}=${data[k]}`)
    .join("&");
}

/**
 * @description 生成新的参数
 * @returns {Object}
 */
function generateNewParams(data = {}) {
  data = Object.assign(generateBaseParams(), data);
  const str = generateSignStr(data);

  data.sign = signature(str);
  return data;
}

/**
 * 睡眠函数
 * @param {Number} time
 * @returns
 */
function sleep(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

function dataReportOld(category, catever, action, label, params) {
  if (window.window.SLBSDK && window.window.SLBSDK.nativeCall) {
    params = params || {};
    if (params) {
      Object.keys(params).forEach((param) => {
        params[param] = encodeURIComponent(params[param]);
      });
    }
    window.window.SLBSDK.nativeCall("SLDataReport", [
      {
        category: category || "",
        catever: catever || "",
        action: action || "",
        label: label || "",
        ...params,
      },
    ]);
  }
}

/**
 * 打桩
 * reportdata = { category: category, action: action, label: label, data: data, checkconfig: 0 }
 * window.pcmjssdk.commonMethod.reportBigdata(JSON.stringify(reportdata)) 管家客户端提供的打桩api
 * @param {*} category
 * @param {*} action
 * @param {*} label
 * @param {*} data
 */
function dataReport(category, action, label, data = {}, checkconfig = 0) {
  console.log('埋点 dataReport', category, action, data)
  if (
    window?.pcmjssdk?.commonMethod?.reportBigdata &&
    typeof window?.pcmjssdk?.commonMethod?.reportBigdata === "function"
  ) {
    const reportdata = {
      category: category,
      action: action,
      label: label,
      data: data,
      checkconfig: checkconfig,
    };
    window?.pcmjssdk?.commonMethod?.reportBigdata(JSON.stringify(reportdata));
  } else {
    console.warn(
      "window.pcmjssdk.commonMethod.reportBigdata 打桩方法请在管家客户端运行"
    );
  }
}
export function forceReportBigData (category, action, label, params) {
  console.log('埋点 forceReportBigData', category, action, params)
  if (!window?.pcmjssdk?.commonMethod) return
  const data = [{ key: 'pcm_version', value: window.pcmjssdk.commonMethod.GetVersion() }]
  if (params) { data.push(...params) }
  // checkconfig 为 0 代表强制上报
  const reportdata = { category: category, action: action, label: label, data: data, checkconfig: 0 }
  window.pcmjssdk.commonMethod.reportBigdata(JSON.stringify(reportdata).replaceAll('\n', '').replaceAll('·', ''))
}

export function isStorage() {
  if (!window.SLBSDK?.version) return false;
  return true;
}

export function setItem(key, value) {
  if (!isStorage()) {
    localStorage.setItem(key, value);
    return Promise.resolve("OK");
  }
  return window.SLBSDK.nativeCall("SLSetItem", [key, value])
    .then((res) => res)
    .catch(() => {
      localStorage.setItem(key, value);
      return Promise.resolve("OK");
    });
}

export function getItem(key) {
  if (!isStorage()) {
    return Promise.resolve(localStorage.getItem(key));
  }
  return window.SLBSDK.nativeCall("SLGetItem", [key])
    .then((res) => {
      res = res === '""' ? "" : res;
      return res;
    })
    .catch(() => {
      return localStorage.getItem(key);
    });
}

export function removeItem(key) {
  if (!isStorage()) {
    localStorage.removeItem(key);
    return Promise.resolve("OK");
  }

  return window.SLBSDK.nativeCall("SLRemoveItem", [key])
    .then((res) => {
      return res;
    })
    .catch(() => {
      localStorage.removeItem(key);
      return "OK";
    });
}

/**
 * 获取默认搜索引擎
 * @param {String} key
 * @returns { Strings} url
 */
export function getDefaultSearchURL(key) {
  if (window.window.SLBSDK && window.window.SLBSDK.nativeCall) {
    return window.SLBSDK.nativeCall("GetDefaultSearchURL", [key]).then(
      (res) => {
        res = res === '""' ? "" : res;
        return res;
      }
    );
  }
}

/**
 * HTML转换为纯文本
 * @param { String } html
 * @returns
 */
export function convertToPlain(html) {
  const tempDivElement = document.createElement("div");
  tempDivElement.innerHTML = html;
  return tempDivElement.textContent || tempDivElement.innerText || "";
}

/**
 * @description 处理console.log方法，手动打开设置window.logDebug.value = true,默认情况下关闭
 */
export function handleConsoleLog() {
  window.logDebug = {
    set value(value) {
      // 打开console.log
      if (value === true && window.logDebug.logFun) {
        window.console.log = window.logDebug.logFun;
      } else {
        window.console.log = () => {};
      }
      // 存储log配置
      localStorage.setItem("logDebugValue", value);
    },
    get value() {
      return this.value;
    },
  };
  // 存储console.log方法
  window.logDebug.logFun = window.console.log;
  // 初始化打印配置
  if (
    localStorage.getItem("logDebugValue") === "true" ||
    process.env.NODE_ENV === "development"
  ) {
    window.logDebug.value = true;
  } else {
    window.logDebug.value = false;
  }
}

export function isJSON(str) {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}

export function deepCopy(source, target) {
  // 深拷贝
  target = target || {};
  for (const key in source) {
    // eslint-disable-next-line
    if (source.hasOwnProperty(key)) {
      if (typeof source[key] === "object" && source[key] !== null) {
        target[key] = Array.isArray(source[key]) ? [] : {};
        deepCopy(source[key], target[key]);
      } else {
        target[key] = source[key];
      }
    }
  }
  return target;
}

export function getTypeByName(filename) {
  const regex = /(?:\.([^.]+))?$/;
  const extension = filename.match(regex)[1].toLowerCase();
  switch (extension) {
    case 'jpg':
    case 'jpeg':
      return 'JPEG';
    case 'png':
      return 'PNG';
    case 'gif':
      return 'GIF';
    case 'bmp':
      return 'BMP';
    case 'svg':
      return 'SVG';
    case 'webp':
      return 'WebP';
    default:
      return ''; // 未知的图片类型
  }
}

export function base64ToFile(base64, filename, mime) {
  try {
    const bstr = atob(base64);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  } catch(error) {
    console.log(error)
    return null
  }
}
export function getFilenameByPath(path) {
  try {
    const regex = /(?:\/([^/]+))?$/;
    const filename = path.match(regex)[1];
    return filename
  } catch(error) {
    console.log(error)
    return null
  }
}


export {
  randomString,
  getsignpart,
  signature,
  generateNewParams,
  sleep,
  dataReport,
  dataReportOld,
};
